import { render, staticRenderFns } from "./HistorialPiezaView.vue?vue&type=template&id=7093a588&scoped=true&lang=pug"
import script from "./HistorialPiezaView.vue?vue&type=script&lang=js"
export * from "./HistorialPiezaView.vue?vue&type=script&lang=js"
import style0 from "./HistorialPiezaView.vue?vue&type=style&index=0&id=7093a588&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7093a588",
  null
  
)

export default component.exports